import { render, staticRenderFns } from "./EventAttendanceDetail.vue?vue&type=template&id=4a8ab431&"
import script from "./EventAttendanceDetail.vue?vue&type=script&lang=js&"
export * from "./EventAttendanceDetail.vue?vue&type=script&lang=js&"
import style0 from "./EventAttendanceDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)


    import installComponents from "!/Users/jurajpetras/dev/pmat/web/frontend/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BAlert, BCol, BRow} from 'bootstrap-vue'
    installComponents(component, {BAlert, BCol, BRow})
    

export default component.exports